import { getKlipSelectedProduct, klipCouponAppliesToProduct, selectKlipAutoCoupon, waitForKlipCartReady } from 'components/klip-coupons'
import{EVENTS}from '@archetype-themes/utils/events'
class BlockBuyButtons extends HTMLElement{constructor(){super()
this.handleVariantChange=this.handleVariantChange.bind(this)}
connectedCallback(){this.abortController=new AbortController()
this.addEventListener('submit',this.handleSubmit.bind(this),{signal:this.abortController.signal})
document.addEventListener(`${EVENTS.variantChange}:${this.dataset.sectionId}:${this.dataset.productId}`,this.handleVariantChange,{signal:this.abortController.signal})
this.cartType=this.dataset.cartType
if(this.dataset.klipRecommendedProduct&&!this.initializeRecommendedButton()){
this.initializationObserver=new MutationObserver(()=>this.initializeRecommendedButton())
this.initializationObserver.observe(this,{childList:!0,subtree:!0})}}
initializeRecommendedButton(){const button=this.querySelector('[name="add"]')
if(!button)return!1
if(button.hasAttribute('data-add-product-awaiting-init')){
button.removeAttribute('data-add-product-awaiting-init')
button.removeAttribute('disabled')}
this.initializationObserver?.disconnect()
return!0}
disconnectedCallback(){this.abortController.abort()
this.initializationObserver?.disconnect()}
handleVariantChange({detail}){const{html,variant,variantUi}=detail
this.toggleAttribute('data-klip-variant-unavailable',!variant)
this.dispatchEvent(new CustomEvent('klip:variant-change',{bubbles:!0}))
if(!variant){this.toggleAddButton(!0,this.getLocales().unavailable)
return}
this.updateVariantInput(variant)
this.renderProductInfo(html,variantUi)}
renderProductInfo(html,variantUi){if(variantUi){this.toggleAddButton(Boolean(variantUi.addButtonDisabled),this.getLocales().soldOut)
return}
if(!html)return
const addButtonUpdated=html.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`)
if(addButtonUpdated){this.toggleAddButton(addButtonUpdated.hasAttribute('disabled'),this.getLocales().soldOut)}}
getLocales(){this.locales=this.locales||JSON.parse(this.querySelector('[type="application/json"]').textContent)
return this.locales}
toggleAddButton(disable=!0,text){const productForm=this.querySelector(`#product-form-${this.dataset.sectionId}`)
if(!productForm)return
const addButton=productForm.querySelector('[name="add"]')
const addButtonText=productForm.querySelector('[name="add"] > span')
if(!addButton)return
if(disable){addButton.setAttribute('disabled','disabled')
if(text)addButtonText.textContent=text}else{addButton.removeAttribute('disabled')
addButtonText.textContent=this.dataset.template!=='preorder'?this.getLocales().addToCart:this.getLocales().preOrder}}
updateVariantInput(variant){const productForms=this.querySelectorAll(`#product-form-${this.dataset.sectionId}, #product-form-installment-${this.dataset.sectionId}`)
productForms.forEach((productForm)=>{const input=productForm.querySelector('input[name="id"]')
input.value=variant.id
input.dispatchEvent(new Event('change',{bubbles:!0}))})}
async handleSubmit(event){if(this.cartType=='page')return
event.preventDefault()
if(this.isSubmitting)return
this.isSubmitting=!0
this.disableAddToCartButton()
try{if(this.dataset.klipRecommendedProduct)await waitForKlipCartReady({signal:this.abortController.signal})
const klipCouponId=this.getActiveKlipCouponId()
const klipProductData=this.klipCouponProductData||null
const previousKlipEntries=await this.getCurrentKlipEntries()
const responseJson=await this.addVariantToCart()
const detail={product:responseJson,addToCartBtn:this.querySelector(`#ProductSubmitButton-${this.dataset.sectionId}`),klipCouponId,klipProductData,previousKlipEntries}
this.dispatchEvent(new CustomEvent(EVENTS.ajaxProductAdded,{bubbles:!0,detail}))
if(this.dataset.klipRecommendedProduct&&detail.cartUpdatePromise)await detail.cartUpdatePromise
}catch(error){if(error.name!=='AbortError')this.handleError(error)}finally{this.isSubmitting=!1;this.enableAddToCartButton()}}
handleError(error){if(error?.status===429)return
if(!error.description){console.warn(error)
return}
let form=this.querySelector('form')
let errors=this.querySelector('form .errors')
if(errors)errors.remove()
let errorDiv=document.createElement('div')
errorDiv.classList.add('errors','text-center')
if(typeof error.description==='object'){errorDiv.textContent=error.message}else{errorDiv.textContent=error.description}
form.append(errorDiv)
this.dispatchEvent(new CustomEvent(EVENTS.ajaxProductError,{bubbles:!0,detail:{errorMessage:error.description}}))}
async addVariantToCart(){const formData=this.getFormDataWithSections()
const response=await fetch(`${window.Shopify.routes.root}cart/add.js`,{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest'},body:formData})
if(!response.ok){throw await response.json()}
return response.json()}
async fetchCart(){return(await fetch(`${window.Shopify.routes.root}cart.js`)).json()}
async getCurrentKlipEntries(){try{const cart=window.SicotasCartSnapshot?await window.SicotasCartSnapshot.get():await this.fetchCart()
if(!cart)return[]
const entries=JSON.parse(cart.attributes?.klipC||'[]')
return Array.isArray(entries)?entries:[]}catch(error){return[]}}
getKlipRecommendedProduct(){const raw=this.dataset.klipRecommendedProduct
if(!raw)return null
try{return JSON.parse(raw)}catch(error){return null}}
getActiveKlipCouponId(){
// A host-page coupon can also target this item without being its best offer.
// Recommended items use their own widget or independently ranked eligible coupons.
const sourceProductId=String((this.dataset.klipRecommendedProduct?this.dataset.productId:this.dataset.klipCouponSourceProductId||this.dataset.productId)||'')
this.klipCouponProductData=null
if(!sourceProductId)return''
// Scope to the submitting product. The same product can also be on the host page.
const scope=this.closest('.page-content[data-product-id]')||document
const couponBox=Array.from(scope.querySelectorAll('.elsklip-coupon-box[data-klip-product][data-product-id]')).find(box=>!box.hasAttribute('data-short')&&String(box.dataset.productId)===sourceProductId)
const officialCouponId=couponBox?.querySelector('[data-cid].active')?.getAttribute('data-cid')||''
const previewCouponId=couponBox?.closest('.quick-shop-klip-coupon')?.querySelector(':scope > [data-sicotas-klip-preview][data-cid]')?.getAttribute('data-cid')||''
let productData=this.getKlipRecommendedProduct()
if(!productData&&couponBox){try{const products=JSON.parse(couponBox.dataset.klipProduct||'{}');productData=products[String(this.dataset.productId)]||null}catch(_error){}}
if(!productData||String(productData.id)!==String(this.dataset.productId))return officialCouponId
this.klipCouponProductData=productData
const coupons=window.KLIP_APP_DATA?.coupons
if(!Array.isArray(coupons))return officialCouponId
window.KLIP_APP_DATA.products=window.KLIP_APP_DATA.products||{}
window.KLIP_APP_DATA.products[String(productData.id)]=productData
window.elsklip?.app?.setProducts?.({[String(productData.id)]:productData})
if(this.hasAttribute('data-klip-variant-unavailable'))return''
const targetProduct=getKlipSelectedProduct(productData,this.querySelector('input[name="id"]')?.value)
if(!targetProduct)return''
const officialCoupon=coupons.find(coupon=>String(coupon.id)===String(officialCouponId))
if(officialCoupon&&!officialCoupon.autoClipped&&klipCouponAppliesToProduct(officialCoupon,targetProduct,{claimed:!0}))return String(officialCouponId)
const previewCoupon=coupons.find(coupon=>String(coupon.id)===String(previewCouponId))
if(previewCoupon&&klipCouponAppliesToProduct(previewCoupon,targetProduct))return String(previewCouponId)
if(officialCoupon&&klipCouponAppliesToProduct(officialCoupon,targetProduct,{claimed:!0}))return String(officialCouponId)
// A regular form must preserve an explicit unclaimed state in the official widget.
if(!this.dataset.klipRecommendedProduct)return''
return String(selectKlipAutoCoupon(coupons,targetProduct)?.id||'')}
getFormDataWithSections(){const productForm=this.querySelector(`#product-form-${this.dataset.sectionId}`)
const formData=new FormData(productForm)
formData.set('sections_url',`${window.Shopify.routes.root}variants/${productForm.id.value}`)
formData.set('sections','cart-ajax,cart-slide-drawer-content')
return formData}
enableAddToCartButton(){const productForm=this.querySelector(`#product-form-${this.dataset.sectionId}`)
if(!productForm)return
const addButton=productForm.querySelector('[name="add"]')
addButton.removeAttribute('aria-busy')
if(this.dataset.klipRecommendedProduct)addButton.removeAttribute('disabled')
addButton.classList.remove('btn--loading')}
disableAddToCartButton(){const productForm=this.querySelector(`#product-form-${this.dataset.sectionId}`)
const errors=this.querySelector('form .errors')
if(errors)errors.remove()
if(!productForm)return
const addButton=productForm.querySelector('[name="add"]')
addButton.setAttribute('aria-busy','true')
if(this.dataset.klipRecommendedProduct){addButton.setAttribute('disabled','disabled')}else{addButton.classList.add('btn--loading')}}}
customElements.define('block-buy-buttons',BlockBuyButtons)
